'use client';

import * as React from 'react';
import { usePathname } from 'next/navigation';
import { ThemeProvider as NextThemesProvider } from 'next-themes';
import { type ThemeProviderProps } from 'next-themes/dist/types';

interface ThemeProviderInterface extends ThemeProviderProps {
    darkThemePathnames: string[];
}

export default function ThemeProvider({
    children,
    darkThemePathnames,
    ...props
}: ThemeProviderInterface) {
    const pathname = usePathname();

    const forcedThemeFromPathname = darkThemePathnames.includes(pathname)
        ? 'dark'
        : undefined;

    return (
        <NextThemesProvider
            forcedTheme={forcedThemeFromPathname}
            {...props}
        >
            {children}
        </NextThemesProvider>
    );
}
